import classNames from 'classnames';
import React from 'react';
import styles from './Count.module.css';

export interface CountProps extends React.HTMLAttributes<HTMLSpanElement> {}

export const Count = ({ className, ...props }: CountProps) => (
  <span className={classNames(styles.count, className)} {...props} />
);
